import 'react-select/dist/react-select.css';

import * as R from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, ControlLabel, FormControl, InputGroup} from 'react-bootstrap';

import LoadingSpinner from 'js/components/loading_spinner';

import {debouncedPromise} from 'js/common/async_helper';

import './index.scss';

class AddressAutoComplete extends Component {
    /**
     * Client used is specified by the renderer
     * to allow this to be rendered in storybook
     * which has no window.sn
     */
    static propTypes = {
        GoogleMapsApi: PropTypes.shape({
            placeDetails: PropTypes.func.isRequired,
            placesQueryAutoComplete: PropTypes.func.isRequired
        }),
        value: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
        validationState: PropTypes.string,

        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        placeholder: '',
        value: '',
        clearable: true,
        validationState: null
    };

    constructor(props) {
        super(props);

        this.state = {
            suggestions: [],
            error: null,
            showSuggestions: false
        };
    }

    handlePlaceSelected = async ({placeid}) => {
        const {GoogleMapsApi, onPlaceSelected} = this.props;

        try {
            this.setState({fetchingPlaces: true, showSuggestions: false});
            const {data: placeDetails} = await GoogleMapsApi.placeDetails({placeid});
            this.setState({fetchingPlaces: false});

            R.pipe(R.prop('result'), onPlaceSelected)(placeDetails);
        } catch (error) {
            return this.setState({error: true, fetchingPlaces: false});
        }
    };

    /**
     * @memberof AddressAutoComplete
     * @param {string} input
     */
    queryForPlaces = debouncedPromise(async input => {
        const {GoogleMapsApi} = this.props;

        try {
            if (R.isEmpty(input)) {
                return;
            }

            this.setState({fetchingPlaces: true});

            const {data: result} = await GoogleMapsApi.placesQueryAutoComplete({
                input,
                types: 'address'
            });

            this.setState({
                suggestions: R.pipe(
                    R.prop('predictions'),
                    R.map(({description, place_id}) => ({
                        description,
                        placeid: place_id
                    }))
                )(result),
                showSuggestions: true,
                error: null,
                fetchingPlaces: false
            });
        } catch (error) {
            this.setState({error: true, fetchingPlaces: false});
        }
    }, 350);

    handleOnChange = input => {
        const {onChange} = this.props;

        onChange(input);

        this.queryForPlaces(input);
    };

    /**
     * We may want to handle down arrow and enter being used to highlight
     * and select items from the list in the future, do so here
     * @param {Event} event
     * @memberof AddressAutoComplete
     */
    handleKeyPresses = event => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    hideSuggestions = () => {
        this.setState({showSuggestions: false});
    };

    toggleSuggestionsVisible = () => {
        this.setState({
            showSuggestions: !this.state.showSuggestions
        });
    };

    renderSuggestions = () => {
        const {suggestions, showSuggestions} = this.state;

        if (!showSuggestions) {
            return null;
        }

        return R.map(suggestion => (
            <li
                key={suggestion.placeid}
                className="suggestions-listitem"
                onClick={() => this.handlePlaceSelected(suggestion)}
            >
                {suggestion.description}
            </li>
        ))(suggestions);
    };

    renderAddonContent = () => {
        const {fetchingPlaces, showSuggestions} = this.state;

        if (fetchingPlaces) {
            return <LoadingSpinner />;
        }

        if (showSuggestions) {
            return <i className="fa fa-times" />;
        }

        return <i className="fa fa-plus" />;
    };

    render() {
        const {value, placeholder, validationState} = this.props;

        const {suggestions, fetchingPlaces} = this.state;

        const hasSuggestions = !R.isNil(suggestions) && !R.isEmpty(suggestions);

        return (
            <FormGroup className="addressautocomplete-container" validationState={validationState}>
                <ControlLabel>Mailing Address</ControlLabel>
                <InputGroup>
                    <FormControl
                        name="profile[address]"
                        type="text"
                        value={value}
                        placeholder={placeholder}
                        onChange={e => this.handleOnChange(e.target.value)}
                        onKeyPress={this.handleKeyPresses}
                        ref={c => {
                            this.addressInput = c;
                        }}
                        autoComplete="user-profile-address-info-auto-complete"
                        style={{fontSize: 16}}
                    />
                    {(hasSuggestions || fetchingPlaces) && (
                        <InputGroup.Addon
                            className="addon-closebutton"
                            onClick={this.toggleSuggestionsVisible}
                        >
                            {this.renderAddonContent()}
                        </InputGroup.Addon>
                    )}
                </InputGroup>

                <div id="suggestions-listcontainer">{this.renderSuggestions()}</div>
            </FormGroup>
        );
    }
}

export default AddressAutoComplete;



// WEBPACK FOOTER //
// ./components/google/maps/address_autocomplete/index.js